export type SchedulingConnectionStatus = 'accepted' | 'revoked';

export type SchedulingRequestStatus = 'confirmed' | 'cancelled';

export interface ConnectedCalendar {
  id: string;
  calendar_id: string;
  calendar_name: string;
  is_included: boolean;
}

export interface SchedulingConnection {
  id: string;
  email: string;
  name: string;
  status: SchedulingConnectionStatus;
  connected_at: string | null;
  is_active: boolean;
  calendars: ConnectedCalendar[];
}

export interface SchedulingConnectionsResponse {
  results: SchedulingConnection[];
}

export interface SchedulingRequest {
  id: string;
  client_name: string;
  attendee_email: string;
  teammate_email: string;
  teammate_name: string;
  scheduled_at: string;
  status: SchedulingRequestStatus;
  created_at: string;
  google_meet_link?: string;
}

export interface SchedulingRequestsResponse {
  results: SchedulingRequest[];
}

export interface ListSchedulingRequestsParams {
  start_date: string;
  end_date: string;
}

export interface UpdateConnectionCalendarsParams {
  connectionId: string;
  calendarIds: string[];
}

export interface OAuthStartResponse {
  authorization_url: string;
}

export function isGoogleCalendarNotConfiguredError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const response = error as { status?: number; responseData?: Record<string, unknown> };
  if (response.status === 503) {
    const detail = response.responseData?.detail;
    return typeof detail === 'string' && detail.includes('GOOGLE_CALENDAR');
  }
  return false;
}
